module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /Users/niko/Work/sketch/antd-pro/ant-design-pro-site/scaffold/node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/object/set-prototype-of.js
// module id = 364
// module chunks = 0